/**
 * Distribution Filters Hook
 *
 * This hook handles filter operations for distribution
 * following single responsibility principle.
 *
 * @module useDistributionFilters
 */

import {useCallback} from 'react';
import {useDistributionStore} from '../store/distributionStore';
import {DistributionFilters} from '../models/distribution.model';

export const useDistributionFilters = () => {
  const {
    filters,
    setFilters,
    resetFilters
  } = useDistributionStore();

  // Update filters (optimized to prevent unnecessary calls)
  const updateFilters = useCallback((newFilters: Partial<DistributionFilters>) => {
    setFilters(newFilters);
  }, [setFilters]);

  return {
    filters,
    updateFilters,
    resetFilters
  };
};
